// extracted by mini-css-extract-plugin
export default {"arrowButton":"OiVR9","iconWrapper":"uMVr-"};